import { Component, OnInit } from '@angular/core';
import { User, AuthService } from '@spartacus/core';
import { Observable, of } from 'rxjs';

@Component({
    selector: 'app-custom-login',
    templateUrl: './custom-login.component.html',
    styleUrls: ['./custom-login.component.scss']
})
export class CustomLoginComponent implements OnInit {
  user$: Observable<User>;

  constructor(private auth: AuthService) {}

  ngOnInit(): void {
    // this.user$ = this.auth.isUserLoggedIn().pipe(
    //   switchMap((isUserLoggedIn) => {
    //     if (isUserLoggedIn) {
    //       return this.userService.get();
    //     } else {
    //       return of(undefined);
    //     }
    //   })
    // );
  }
}
